<template>
  <div
    class="range-category-filter-item rcfi"
    :class="[
      { 'range-category-filter-item_locked': isLocked },
      { gw_btn_hover_back_active: isSelected },
      { 'gw_btn_hover_back rcfi_hoverable': !readOnly },
    ]"
    :data-tst="`category_${item.name}`"
  >
    <div
      v-if="!skeleton"
      class="rcfi_left"
    >
      <div
        class="rcfi_title"
        :title="$t(`browse.filter_rules.${item.name}`)"
      >
        {{ $t(`browse.filter_rules.${item.name}`) }}
      </div>
      <div
        v-if="isLocked"
        class="rcfi_lock mdi mdi-lock"
      ></div>
      <div class="rcfi_value">{{ numFixed(hero.total_occurrence * 100, 1) }}%</div>
    </div>
    <div class="rcfi_right">
      <div
        v-if="hasArrowBtn"
        class="rcfi_arrow-btn csst gw_btn gw_btn_outline"
        style="--height: var(--size); --width: var(--size); --clr-back: var(--clr-black-2)"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
        @click.stop="$emit('arrow:click')"
      >
        <div
          class="mdi mdi-chevron-up transition_03"
          :class="{ rotated_180_before: arrowBtnDown }"
        ></div>
        <div
          class="csst_content text-nowrap"
          style="position: fixed"
        >
          {{ arrowBtnDown ? $t('tooltips.select_all_above') : $t('tooltips.select_all_above') }}
        </div>
      </div>
      <div
        v-if="hasFilterBtn"
        class="rcfi_arrow-btn csst gw_btn gw_btn_outline"
        style="--height: var(--size); --width: var(--size); --clr-back: var(--clr-black-2)"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
        @click.stop="$emit('filter:click')"
      >
        <div class="mdi mdi-filter"></div>
        <div
          class="csst_content text-nowrap"
          style="position: fixed"
        >
          {{ $t('tooltips.filter_toggle_category') }}
          <span
            class="keyboardkey_key"
            v-html="'Right-click'"
          ></span>
        </div>
      </div>
      <div
        class="graph-horizontal_small graph-horizontal filter-item-chart"
        style="--clr-back-chart: var(--clr-cc-chart-back)"
      >
        <div
          v-for="(action, idx) in hero.solution"
          :key="`${action.code}_${idx}`"
          class="graph-horizontal_item rcfi_chart"
          :class="action.css_class"
          :style="`width: ${
            (useTotalOccurenceNormalized ? hero.total_occurrence_normalized : 1) *
            action.total_frequency *
            100
          }%; ${useHex ? `background:${action.hex}` : ``}`"
        />
      </div>
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'RangeCategoryFilterItem',
  mixins: [format_mix, float_mix],
  props: {
    item: Object,
    readOnly: Boolean,
    // hasCheckbox: { type: Boolean,  default: true },
    hasArrowBtn: { type: Boolean, default: true },
    hasFilterBtn: Boolean,
    arrowBtnDown: { type: Boolean, default: true },
    useHex: { type: Boolean, default: true },
    useTotalOccurenceNormalized: Boolean,
    isSelected: Boolean,
    isLocked: Boolean,
    skeleton: Boolean,
  },
  emits: ['arrow:click', 'filter:click'],
  computed: {
    hero() {
      return this.item.players[0]
    },
  },
}
</script>

<style lang="scss" scoped>
.rcfi {
  display: flex;
  width: 100%;
  align-items: center;
  line-height: 1.2;

  --radius: 4px;
  --clr-text: var(--clr-white-0);
  --clr-value: var(--clr-text);
  --text-size: 1rem;
  --text-weight: 500;
  --text-transform: normal;

  --icon-lock-size: 1rem;

  --clr-back: transparent;
  --clr-back-hover: var(--clr-black-2-1);
  --clr-back-active: var(--clr-black-2-1);
  --padding: 0;

  --clr-cc-chart-back: var(--clr-black-3);

  --btn-back-z-index: 0;
  --btn-back-inset: 0 auto auto -0.25rem;
  --btn-back-width: calc(100% + 0.5rem);

  background: var(--clr-back);
  text-transform: var(--text-transform);
  font-size: var(--text-size);
  font-weight: var(--text-weight);
  padding: var(--padding);
  border-radius: var(--radius);
  // &:hover {
  //   z-index: 4;
  // }
  &_active {
    --clr-back: var(--clr-back-active);
  }
  &_left {
    display: flex;
    align-items: center;
    max-width: clamp(1rem, 13rem, 55%);
    width: 100%;
    position: relative;
    z-index: 2;
  }
  &_right {
    display: flex;
    align-items: center;
    flex: 1;
    position: relative;
    z-index: 1;
  }
  &_title {
    width: 100%;
    position: relative;
    color: var(--clr-text);
    background: var(--clr-back);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &_icon-lock {
    cursor: pointer;
    font-size: calc(var(--icon-lock-size) * 0.75);
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &_checkbox {
    margin: 0 0.25rem;
  }
  &_value {
    padding: 0 0.5rem 0 0.25rem;
    display: flex;
    align-items: center;
    color: var(--clr-value);
    margin-left: auto;
  }
  &_chart {
    transition: 0.15s;
  }
  &_arrow-btn {
    position: absolute;
    left: -2px;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    // background: var(--clr-black-1-3);
    font-size: 1.5rem;
    --size: 2rem;
    padding: 0;
    // min-height: var(--size);
    // min-width: var(--size);
    // border-radius: 4px;
    pointer-events: none;
    // left: -3px;
    z-index: 6;
    opacity: 0;
    // opacity: 1;
  }
}

@media (hover: hover) and (pointer: fine) {
  .rcfi_hoverable {
    cursor: pointer;
    &:hover {
      z-index: 6;
      .rcfi_arrow-btn {
        opacity: 1;
        pointer-events: all;
        transition: 0.15s;
      }
    }
  }
}

@media (pointer: coarse) {
  .rcfi_arrow-btn {
    display: none;
  }
}
</style>
